import { Controller } from "@hotwired/stimulus"

// Toggles a full-width inline panel row that follows this row (the editor
// expands the table inline instead of floating over other rows). A row can
// carry more than one panel (status + renew); the button's
// data-row-toggle-panel-param picks which class to open (default:
// status-panel-row), walking over the sibling panel rows and closing the
// others so only one panel is open per row.
export default class extends Controller {
  toggle(event) {
    const target = (event && event.params && event.params.panel) || "status-panel-row"
    const row = this.element.closest("tr")
    let sib = row && row.nextElementSibling
    while (sib && (sib.classList.contains("status-panel-row") || sib.classList.contains("renew-panel-row"))) {
      if (sib.classList.contains(target)) {
        sib.style.display = sib.style.display === "none" ? "table-row" : "none"
      } else {
        sib.style.display = "none"
      }
      sib = sib.nextElementSibling
    }
  }
}
